import { useEffect, useState } from 'react'

/** Returns how far the page has been scrolled, from 0 to 1. */
export function useScrollProgress(): number {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    function update() {
      const scrollable = document.body.scrollHeight - window.innerHeight
      const value = scrollable <= 0 ? 0 : window.scrollY / scrollable
      setProgress(Math.min(1, Math.max(0, value)))
    }

    update()
    window.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [])

  return progress
}
